"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAbsoluteMailtoOrHashLink = getAbsoluteMailtoOrHashLink;
exports.getPopoverLinkSettings = getPopoverLinkSettings;
exports.getPopoverTarget = getPopoverTarget;
exports.getSelectedLinkInfo = getSelectedLinkInfo;
exports.escapeRegExp = escapeRegExp;
exports.truncateSameDomainLink = truncateSameDomainLink;
exports.handleLinkInfoSave = handleLinkInfoSave;
exports.getUnlinkHandler = getUnlinkHandler;
exports.getAnchorPreviewClickHandler = exports.onLinkUpdate = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _utils = require("../utils");

var _url = require("../utils/url");

var _link = require("../utils/link");

var _hslink = require("../constants/hslink");

function createLinkInfoObj(linkNode, editor) {
  var _ref;

  return _ref = {}, (0, _defineProperty2.default)(_ref, _hslink.LINK_URL_KEY, editor.dom.getAttrib(linkNode, 'href')), (0, _defineProperty2.default)(_ref, _hslink.LINK_TARGET_BLANK_KEY, editor.dom.getAttrib(linkNode, 'target').indexOf('_blank') !== -1), (0, _defineProperty2.default)(_ref, _hslink.LINK_NOFOLLOW_KEY, editor.dom.getAttrib(linkNode, 'rel').indexOf('nofollow') !== -1), _ref;
}

function getSavedHref(savedLinkInfo) {
  return savedLinkInfo[_hslink.savedLinkFields.HREF];
}

function getAbsoluteMailtoOrHashLink(editor, href) {
  if ((0, _url.isRawUrl)(href)) {
    return href;
  } else if (href[0] === '/') {
    return (0, _link.convertRootRelLinkToAbsUrl)(editor, href);
  }

  return (0, _link.convertPageRelLinkToAbsUrl)(editor, href);
}

function getPopoverLinkSettings(editor) {
  return (0, _utils.getPluginSetting)(editor, _hslink.LINK_SETTINGS);
}

function getPopoverTarget($selectedLink) {
  if ($selectedLink.contents().length === 1) {
    return $selectedLink.children().first().is('img') ? $selectedLink.children().first() : $selectedLink;
  }

  return $selectedLink;
}

function getSelectedLinkNode(ed, selectedNode) {
  return ed.dom.getParent(selectedNode, 'a[href]');
}

function getSelectedLinkInfo(editor) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var linkType = options.linkType;
  var selectedLinkNode = getSelectedLinkNode(editor, editor.selection.getNode());
  var linkInfo;

  if (selectedLinkNode) {
    linkInfo = createLinkInfoObj(selectedLinkNode, editor);
  }

  return (0, _extends2.default)({}, linkInfo, {
    linkType: linkType
  });
}

function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}

function truncateSameDomainLink(contentDomain, href) {
  if (!href || !contentDomain) {
    return href;
  }

  var regex = new RegExp("^https?://" + escapeRegExp(contentDomain));
  return href.replace(regex, '') || '/';
}

function handleLinkInfoSave(editor, savedLinkInfo) {
  if (!savedLinkInfo[_hslink.savedLinkFields.HREF]) {
    editor.execCommand('unlink');
    return;
  }

  var selectedLinkNode = getSelectedLinkNode(editor, editor.selection.getNode());

  if (!savedLinkInfo[_hslink.savedLinkFields.TEXT] && editor.selection.isCollapsed() && !(0, _link.selectionIsWithinLink)(editor)) {
    savedLinkInfo[_hslink.savedLinkFields.TEXT] = savedLinkInfo[_hslink.savedLinkFields.HREF];
  }

  var allowRelativeLinks = (0, _utils.getLinkPluginSetting)(editor, _hslink.hslinkConfig.ALLOW_RELATIVE_LINKS);

  if (allowRelativeLinks) {
    savedLinkInfo[_hslink.savedLinkFields.HREF] = truncateSameDomainLink(editor.settings.contentDomain, getSavedHref(savedLinkInfo));
  }

  (0, _link.insertOrEditLink)(editor, savedLinkInfo, selectedLinkNode);
}

function getUnlinkHandler(editor) {
  return function () {
    editor.execCommand('unlink');
  };
}

var onLinkUpdate = function onLinkUpdate(editor, linkOptions) {
  var linkSettings = (0, _link.adaptLinkPropsToAttr)(linkOptions);
  handleLinkInfoSave(editor, linkSettings);
};

exports.onLinkUpdate = onLinkUpdate;

var getAnchorPreviewClickHandler = function getAnchorPreviewClickHandler(editor) {
  return function (href) {
    if (!href.startsWith('#')) return;
    var anchor = editor.$(href)[0];

    if (anchor) {
      anchor.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
};

exports.getAnchorPreviewClickHandler = getAnchorPreviewClickHandler;